var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Checkbox, Divider, Form, Grid, Input, Select } from "semantic-ui-react";
import ErrorDisplay from "../../ErrorDisplay";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Channel, channelsForPlexity, Plexity, ProKitConfig } from "../../KitDeserializer";
import { postJsonWithAuthn } from "../../RequestHelpers";
import { buildOnComponentStateChangeHandler, } from "../FormState";
import { findChromogenPresetScale, findDetectPresetScale, findProbePresetScale } from "../manual-pro/ManualProConsumerDetectForm";
import { discountMessage, priceColumn, PriceDisplay, ToggleableKitComponent } from "../rna-fish/EditKitForm";
import { ErrorElementsWithPrices } from "../rna-fish/NewRnaFishKitPage";
import { uniqueBy } from "../rna-fish/ProbeSetForm";
import { AmplifierForm } from "./AmplifierForm";
import ChromogenForm from "./ChromogenForm";
import { getProbeAmps, ProtocolTypeEnum } from "./EditKitForm";
import RnaCishAdminKitSerializer from "./KitSerializer";
import MiscellaneousComponentForm from "./MiscellaneousComponentForm";
import ProbeSetForm, { RnaCishEditableOrganism, RnaCishEditableTarget } from "./ProbeSetForm";
import { EnzymeEnum, TargetDesignType } from "./RnaCatalog";
var AdminEditKitForm = /** @class */ (function (_super) {
    __extends(AdminEditKitForm, _super);
    function AdminEditKitForm(props) {
        var _this = _super.call(this, props) || this;
        _this.onMiscComponentStateChange = buildOnComponentStateChangeHandler(miscComponentStateWrangler, _this.props.setFormState);
        _this.onMiscComponentEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { miscComponentEnabled: !s.miscComponentEnabled };
            }, function (newState) {
                if (newState.miscComponentEnabled) {
                    _this.onMiscComponentStateChange({}, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onProbeSetEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { probeSetEnabled: !s.probeSetEnabled };
            }, function (newState) {
                if (newState.probeSetEnabled) {
                    _this.onProbeSetStateChange({}, undefined, _this.onUserSelection);
                }
                else {
                    _this.onUserSelection();
                }
            });
        };
        _this.onProbeSetStateChange = function (updateObjOrFn, channel, callback) {
            _this.props.setFormState(function (oldState) {
                var newState = oldState.probeSetState
                    .map(function (pss) {
                    if (channel && channel === pss.channel) {
                        var setState = void 0;
                        if (typeof updateObjOrFn === "function") {
                            setState = updateObjOrFn(pss.state);
                        }
                        else {
                            setState = updateObjOrFn;
                        }
                        var variant = _this.findVariantForProbeSet(__assign(__assign({}, pss.state), setState));
                        var presetScale = _this.probePresetScale(variant, undefined, undefined, undefined, pss.channel);
                        var probeSetState = __assign(__assign({}, pss.state), setState);
                        if (presetScale) {
                            probeSetState = _this.populateProbeStateWithPresetScale(probeSetState, presetScale);
                        }
                        var newProbeSetState = {
                            state: probeSetState,
                            channel: channel,
                            metadata: presetScale
                        };
                        return Object.assign({}, pss, newProbeSetState);
                    }
                    else {
                        return pss;
                    }
                });
                return {
                    probeSetState: newState
                };
            }, function (newState) {
                if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onAmpStateChange = function (updateObjOrFn, callback) {
            _this.props.setFormState(function (oldState) {
                var setState;
                if (typeof updateObjOrFn === "function") {
                    setState = updateObjOrFn(oldState.detectState);
                }
                else {
                    setState = updateObjOrFn;
                }
                return __assign(__assign({}, oldState), { detectState: Object.assign({}, oldState.detectState, setState) });
            }, function (newState) {
                if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onChromogenStateChange = function (updateObjOrFn, callback) {
            _this.props.setFormState(function (oldState) {
                var setState;
                if (typeof updateObjOrFn === "function") {
                    setState = updateObjOrFn(oldState.chromogenState);
                }
                else {
                    setState = updateObjOrFn;
                }
                var chromogenPresetScale = _this.chromogenPresetScale(undefined, undefined, setState.chromogen);
                var newChromogenState = Object.assign({}, oldState.chromogenState, setState);
                if (chromogenPresetScale) {
                    newChromogenState = populateChromogenStateWithPresetScales(newChromogenState, chromogenPresetScale);
                }
                return __assign(__assign({}, oldState), { chromogenPresetScale: chromogenPresetScale, chromogenState: newChromogenState });
            }, function (newState) {
                if (callback) {
                    callback(newState);
                }
            });
        };
        _this.onCommentChange = function (event) {
            var str = event.currentTarget.value;
            _this.props.setFormState(function () {
                return {
                    comment: str
                };
            });
        };
        _this.onProtocolChange = function (_, data) {
            var platform = _this.props.catalog.proPlatforms.find(function (p) { return p.id === data.value; });
            if (platform) {
                var plexity_1 = _this.props.formState.plexity;
                // get the amp catalog for the current plexity under the newPlatform
                var ampCatalog = _this.getAmpCatalog(plexity_1 === Plexity.TwoPlex);
                var probeAmps_1 = getProbeAmps(ampCatalog, platform);
                // choose the appropriate detect preset scale for the newPlatform/plexity/scale
                var detectPresetScale_1 = _this.detectPresetScale(undefined, platform, undefined);
                var fallbackDetectState_1 = defaultAutomatedProDetectState(_this.props.catalog.proAmplifier, platform, plexity_1, detectPresetScale_1);
                var detectChannels_1 = _this.buildDetectChannels(ampCatalog, platform, plexity_1, fallbackDetectState_1);
                // choose the appropriate chromogen preset scale for the newPlatform/scale
                var chromogenPresetScale_1 = _this.chromogenPresetScale(undefined, platform, undefined);
                _this.props.setFormState(function (oldState) {
                    var probeSetState = _this.rescaleProbeSetState(oldState.probeSetState, platform, plexity_1, probeAmps_1);
                    var newDetectState = __assign(__assign({}, fallbackDetectState_1), { channels: detectChannels_1, prefilled: oldState.detectState.prefilled, customPrice: oldState.detectState.customPrice });
                    if (detectPresetScale_1) {
                        newDetectState = populateDetectStateWithPresetScales(newDetectState, detectPresetScale_1);
                    }
                    return {
                        platform: platform,
                        probeSetState: probeSetState,
                        detectPresetScale: detectPresetScale_1,
                        detectState: newDetectState,
                        chromogenPresetScale: chromogenPresetScale_1,
                        chromogenState: chromogenPresetScale_1
                            ? populateChromogenStateWithPresetScales(oldState.chromogenState, chromogenPresetScale_1)
                            : oldState.chromogenState
                    };
                }, _this.onUserSelection);
            }
        };
        _this.getAmpCatalog = function (addedSecondTarget) {
            var amplifierCatalog = _this.props.catalog.proAmplifier;
            var ampCatalog;
            if (addedSecondTarget) {
                ampCatalog = amplifierCatalog.userConfigs.twoTargetProAmps;
            }
            else {
                ampCatalog = amplifierCatalog.userConfigs.oneTargetProAmps;
            }
            return ampCatalog;
        };
        _this.getSelectedEnzyme = function (ampCatalog, channel, protocolType, enzymeCompatibility) {
            return ampCatalog
                .proAmpConfigList
                .find(function (c) {
                return c.label === (enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.label) &&
                    c.platformCompatibility.find(function (pc) { return pc.id === (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id); }) != null &&
                    c.channelNum === channel;
            });
        };
        _this.buildDetectChannels = function (ampCatalog, platform, plexity, fallbackDetectState) {
            var overrideChannel = function (fallback, config) {
                var _a, _b, _c;
                return (__assign(__assign({}, fallback), { config: config, hcrAmplifier: (_a = config === null || config === void 0 ? void 0 : config.amplifier) !== null && _a !== void 0 ? _a : fallback.hcrAmplifier, hapten: (_b = config === null || config === void 0 ? void 0 : config.hapten) !== null && _b !== void 0 ? _b : fallback.hapten, enzyme: (_c = config === null || config === void 0 ? void 0 : config.enzyme) !== null && _c !== void 0 ? _c : fallback.enzyme }));
            };
            // set enzyme config for each detect channel implied by the plexity, preserving the
            // user's current selection where it's still compatible with the new plexity/platform
            return channelsForPlexity(plexity).map(function (channel, index) {
                var _a, _b, _c;
                var config = (_c = _this.getSelectedEnzyme(ampCatalog, channel, platform, (_b = (_a = _this.props.formState.detectState.channels[index]) === null || _a === void 0 ? void 0 : _a.config) !== null && _b !== void 0 ? _b : undefined)) !== null && _c !== void 0 ? _c : fallbackDetectState.channels[index].config;
                return overrideChannel(fallbackDetectState.channels[index], config);
            });
        };
        _this.rescaleProbeSetState = function (probeSetState, platform, plexity, probeAmps) {
            // set amp for each probe channel, and choose the appropriate probe preset scale
            return probeSetState.map(function (pss) {
                var _a, _b, _c, _d, _e, _f;
                var amp = (_b = (_a = probeAmps.find(function (a) { return a.channel === pss.channel; })) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : pss.state.hcrAmplifier;
                var variant = _this.findVariantForProbeSet(pss.state);
                var presetScale = _this.probePresetScale(variant, undefined, platform, plexity, pss.channel);
                return {
                    state: __assign(__assign({}, pss.state), { hcrAmplifier: amp, probeScalePmol: (_c = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeSetScalePmol) !== null && _c !== void 0 ? _c : pss.state.probeScalePmol, probeScaleUl: (_d = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeSetScaleUl) !== null && _d !== void 0 ? _d : pss.state.probeScaleUl, probeHybridizationAScale: (_e = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeHybridizationBufferUl) !== null && _e !== void 0 ? _e : pss.state.probeHybridizationAScale, probeHybridizationBScale: (_f = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeHybridizationBufferUl) !== null && _f !== void 0 ? _f : pss.state.probeHybridizationBScale }),
                    channel: pss.channel,
                    metadata: presetScale
                };
            });
        };
        _this.onPlexityChange = function (_, data) {
            var _a;
            var plexity = data.value;
            var platform = _this.props.formState.platform.plexity.includes(plexity)
                ? _this.props.formState.platform
                : (_a = _this.props.catalog.proPlatforms.find(function (p) { return p.plexity.includes(plexity); })) !== null && _a !== void 0 ? _a : _this.props.formState.platform;
            // get the amp catalog for the target plexity
            var ampCatalog = _this.getAmpCatalog(plexity === Plexity.TwoPlex);
            var probeAmps = getProbeAmps(ampCatalog, platform);
            // choose the appropriate detect preset scale for the target plexity/newPlatform/scale
            var detectPresetScale = _this.detectPresetScale(undefined, platform, plexity);
            var fallbackDetectState = defaultAutomatedProDetectState(_this.props.catalog.proAmplifier, platform, plexity, detectPresetScale);
            var detectChannels = _this.buildDetectChannels(ampCatalog, platform, plexity, fallbackDetectState);
            _this.props.setFormState(function (oldState) {
                var _a, _b, _c, _d, _e;
                var rescaledProbeSetState = _this.rescaleProbeSetState(oldState.probeSetState, platform, plexity, probeAmps);
                // add a second probe set form state when moving to two plex
                var probeSetState = rescaledProbeSetState;
                if (plexity === Plexity.TwoPlex && rescaledProbeSetState.length < 2) {
                    var ch2Amp = (_b = (_a = probeAmps
                        .find(function (a) { return a.channel === Channel.Channel2; })) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : _this.props.catalog.proAmplifier.defaultHcrAmplifier;
                    var ch2PresetScale = _this.probePresetScale(undefined, undefined, platform, plexity, Channel.Channel2);
                    probeSetState = rescaledProbeSetState.concat([{
                            state: defaultAutomatedProCatalogProbeSetState(_this.props.catalog, ch2Amp, ch2PresetScale),
                            channel: Channel.Channel2,
                            metadata: ch2PresetScale
                        }]);
                }
                else if (plexity === Plexity.OnePlex) {
                    probeSetState = rescaledProbeSetState.slice(0, 1);
                }
                var newDetectState = __assign(__assign({}, fallbackDetectState), { channels: detectChannels, prefilled: oldState.detectState.prefilled, customPrice: oldState.detectState.customPrice });
                if (detectPresetScale) {
                    newDetectState = populateDetectStateWithPresetScales(newDetectState, detectPresetScale);
                }
                var chromogenPresetScale = _this.chromogenPresetScale(undefined, undefined, undefined);
                var newChromogenState = _this.props.formState.chromogenState;
                if (chromogenPresetScale) {
                    newChromogenState = populateChromogenStateWithPresetScales(_this.props.formState.chromogenState, chromogenPresetScale);
                }
                // Set Custom prices if they're toggled on
                var customPriceEnabled = _this.props.formState.customPriceEnabled;
                probeSetState = probeSetState.map(function (pss) {
                    var _a, _b;
                    return (__assign(__assign({}, pss), { state: __assign(__assign({}, pss.state), { customPrice: _this.customPriceFor(customPriceEnabled, (_b = (_a = _this.props.formState.price) === null || _a === void 0 ? void 0 : _a.effectivePrice.probeSetPriceCents.find(function (price) { return price.channel === pss.channel; })) === null || _b === void 0 ? void 0 : _b.price) }) }));
                });
                newDetectState = __assign(__assign({}, newDetectState), { customPrice: _this.customPriceFor(customPriceEnabled, (_c = _this.props.formState.price) === null || _c === void 0 ? void 0 : _c.effectivePrice.detectPriceCents) });
                newChromogenState = __assign(__assign({}, newChromogenState), { customPrice: _this.customPriceFor(customPriceEnabled, (_d = _this.props.formState.price) === null || _d === void 0 ? void 0 : _d.effectivePrice.chromogenPriceCents) });
                var miscState = __assign(__assign({}, oldState.miscComponentState), { customPrice: _this.customPriceFor(customPriceEnabled, (_e = _this.props.formState.price) === null || _e === void 0 ? void 0 : _e.effectivePrice.miscComponentPriceCents) });
                return {
                    plexity: plexity,
                    platform: platform,
                    probeSetState: probeSetState,
                    detectPresetScale: detectPresetScale,
                    detectState: newDetectState,
                    chromogenPresetScale: chromogenPresetScale,
                    chromogenState: newChromogenState,
                    miscComponentState: miscState
                };
            }, _this.onUserSelection);
        };
        // TODO on configuration change have to make a two plex kit one plex and make sure the proper configuration is applied
        // TODO starter kit
        _this.onConfigurationChange = function (_, data) {
            var config = data.value;
            _this.props.setFormState(function (oldState) {
                if (config === ProKitConfig.Other) {
                    return {
                        config: config,
                        probeSetEnabled: true,
                        detectEnabled: true,
                        chromogenEnabled: true,
                        miscComponentEnabled: true,
                        plexity: Plexity.OnePlex
                    };
                }
                var detectPresetScale = _this.detectPresetScale(undefined, undefined, undefined);
                var chromogenPresetScale = _this.chromogenPresetScale(undefined, undefined, undefined);
                return {
                    config: config,
                    probeSetEnabled: config === ProKitConfig.ProbeDetect
                        || config === ProKitConfig.ProbeOnly
                        || config === ProKitConfig.StarterKitProbe,
                    detectEnabled: config === ProKitConfig.ProbeDetect
                        || config === ProKitConfig.DetectOnly,
                    chromogenEnabled: config === ProKitConfig.ProbeDetect
                        || config === ProKitConfig.DetectOnly
                        || config === ProKitConfig.ExtrasOnly,
                    miscComponentEnabled: false,
                    reasonForOther: oldState.config === ProKitConfig.Other ? "" : oldState.reasonForOther,
                    reasonForOtherExplanation: oldState.config === ProKitConfig.Other ? "" : oldState.reasonForOtherExplanation,
                    probeSetState: _this.props.formState.probeSetState
                        .sort(function (c1, c2) { return c1.channel - c2.channel; })
                        .map(function (pss) {
                        var variant = _this.findVariantForProbeSet(pss.state);
                        var presetScale = _this.probePresetScale(variant, undefined, undefined, undefined, pss.channel);
                        return {
                            state: presetScale ? _this.populateProbeStateWithPresetScale(pss.state, presetScale) : pss.state,
                            channel: pss.channel,
                            metadata: presetScale
                        };
                    }),
                    detectState: detectPresetScale ? populateDetectStateWithPresetScales(_this.props.formState.detectState, detectPresetScale) : _this.props.formState.detectState,
                    detectPresetScale: detectPresetScale,
                    chromogenState: chromogenPresetScale ? populateChromogenStateWithPresetScales(_this.props.formState.chromogenState, chromogenPresetScale) : _this.props.formState.chromogenState,
                    chromogenPresetScale: chromogenPresetScale
                };
            }, _this.onUserSelection);
        };
        _this.otherReasons = function () {
            return [
                {
                    text: "Troubleshooting",
                    value: "Troubleshooting"
                },
                {
                    text: "Beta Testing",
                    value: "Beta Testing"
                },
                {
                    text: "Product Partnership",
                    value: "Product Partnership"
                },
                {
                    text: "Sales Misc.",
                    value: "Sales Misc."
                }
            ];
        };
        _this.onReasonForOtherChange = function (_, data) {
            _this.props.setFormState(function () {
                return {
                    reasonForOther: data.value
                };
            }, _this.onUserSelection);
        };
        _this.onReasonForOtherExplanationChange = function (_, data) {
            _this.props.setFormState(function () {
                return {
                    reasonForOtherExplanation: data.value
                };
            }, _this.onUserSelection);
        };
        _this.onScaleChange = function (_, data) {
            var scale = data.value;
            var probeSetState = _this.props.formState.probeSetState
                .sort(function (s1, s2) { return (s1.channel - s2.channel); })
                .map(function (pss) {
                var variant = _this.findVariantForProbeSet(pss.state);
                var presetScale = _this.probePresetScale(variant, scale, undefined, undefined, pss.channel);
                return {
                    state: presetScale ? _this.populateProbeStateWithPresetScale(pss.state, presetScale) : pss.state,
                    channel: pss.channel,
                    metadata: presetScale
                };
            });
            var detectPresetScale = _this.detectPresetScale(scale, undefined, undefined);
            var detectState;
            if (detectPresetScale) {
                detectState = populateDetectStateWithPresetScales(_this.props.formState.detectState, detectPresetScale);
            }
            // if the newPlatform is ROCHE then prefilled tracks whether the 90 scale is selected,
            // otherwise prefilled is always false
            var prefilled = _this.props.formState.platform.id === ProtocolTypeEnum.ROCHE && scale === 90;
            var chromogenPresetScale = _this.chromogenPresetScale(scale, undefined, undefined);
            var chromogenState;
            if (chromogenPresetScale) {
                chromogenState = populateChromogenStateWithPresetScales(_this.props.formState.chromogenState, chromogenPresetScale);
            }
            _this.props.setFormState(function (oldState) {
                return __assign(__assign({}, oldState), { probeSetState: probeSetState,
                    detectPresetScale: detectPresetScale, detectState: __assign(__assign({}, (detectState !== null && detectState !== void 0 ? detectState : oldState.detectState)), { prefilled: prefilled }), chromogenPresetScale: chromogenPresetScale, chromogenState: chromogenState !== null && chromogenState !== void 0 ? chromogenState : oldState.chromogenState, scale: scale });
            }, _this.onUserSelection);
        };
        _this.effectiveScales = function () {
            return uniqueBy(_this.props.catalog.automatedProScaleOptions, function (s) { return s; });
        };
        _this.onAmplifierEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { detectEnabled: !s.detectEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onChromogenEnableChange = function () {
            _this.props.setFormState(function (s) {
                return { chromogenEnabled: !s.chromogenEnabled };
            }, function () {
                _this.onUserSelection();
            });
        };
        _this.onCustomPriceEnabledChange = function (_, data) {
            var customPriceEnabled = !!data.checked;
            _this.props.setFormState(function (oldState) {
                var _a, _b, _c;
                var probeSetState = oldState.probeSetState.map(function (pss) {
                    var _a, _b;
                    return (__assign(__assign({}, pss), { state: __assign(__assign({}, pss.state), { customPrice: _this.customPriceFor(customPriceEnabled, (_b = (_a = _this.props.formState.price) === null || _a === void 0 ? void 0 : _a.effectivePrice.probeSetPriceCents.find(function (price) { return price.channel === pss.channel; })) === null || _b === void 0 ? void 0 : _b.price) }) }));
                });
                var detectState = __assign(__assign({}, oldState.detectState), { customPrice: _this.customPriceFor(customPriceEnabled, (_a = _this.props.formState.price) === null || _a === void 0 ? void 0 : _a.effectivePrice.detectPriceCents) });
                var chromogenState = __assign(__assign({}, oldState.chromogenState), { customPrice: _this.customPriceFor(customPriceEnabled, (_b = _this.props.formState.price) === null || _b === void 0 ? void 0 : _b.effectivePrice.chromogenPriceCents) });
                var miscState = __assign(__assign({}, oldState.miscComponentState), { customPrice: _this.customPriceFor(customPriceEnabled, (_c = _this.props.formState.price) === null || _c === void 0 ? void 0 : _c.effectivePrice.miscComponentPriceCents) });
                return {
                    customPriceEnabled: customPriceEnabled,
                    probeSetState: probeSetState,
                    detectState: detectState,
                    chromogenState: chromogenState,
                    miscState: miscState
                };
            }, _this.onUserSelection);
        };
        _this.onUserSelection = function () {
            _this.loadPrice();
        };
        _this.loadPrice = function () {
            _this.props.setFormState(function () { return ({
                priceLoading: true
            }); }, function (newState) {
                postJsonWithAuthn(_this.props.kitPriceUrlPath, JSON.stringify(AdminEditKitForm.serializeAutomatedProKit(newState)))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) { return new ErrorElementsWithPrices(json.errors, json.price); });
                    }
                    return resp.json();
                }).then(function (resp) {
                    if (resp instanceof ErrorElementsWithPrices) {
                        _this.props.setFormState(function () { return ({
                            errors: resp.errors,
                            priceLoading: false,
                            price: resp.price
                        }); });
                    }
                    else {
                        _this.props.setFormState(function () { return ({
                            errors: [],
                            price: resp,
                            priceLoading: false
                        }); });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't update price: " + rej);
                });
            });
        };
        _this.probePresetScale = function (variant, newScale, newPlatform, newPlexity, channel) {
            var _a, _b, _c;
            return findProbePresetScale(_this.props.catalog.presetScales, ((_a = newPlatform === null || newPlatform === void 0 ? void 0 : newPlatform.id) !== null && _a !== void 0 ? _a : (_b = _this.props.formState.platform) === null || _b === void 0 ? void 0 : _b.id), variant, (_c = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.scale) !== null && _c !== void 0 ? _c : _this.props.catalog.defaultAutomatedProScale, newPlexity !== null && newPlexity !== void 0 ? newPlexity : _this.props.formState.plexity, channel);
        };
        _this.detectPresetScale = function (newScale, newPlatform, newPlexity) {
            var _a, _b, _c;
            return findDetectPresetScale(_this.props.catalog.presetScales, ((_a = newPlatform === null || newPlatform === void 0 ? void 0 : newPlatform.id) !== null && _a !== void 0 ? _a : (_b = _this.props.formState.platform) === null || _b === void 0 ? void 0 : _b.id), (_c = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.scale) !== null && _c !== void 0 ? _c : _this.props.catalog.defaultAutomatedProScale, newPlexity !== null && newPlexity !== void 0 ? newPlexity : _this.props.formState.plexity, false);
        };
        _this.chromogenPresetScale = function (newScale, newPlatform, newChromogen) {
            var _a, _b, _c, _d;
            var chromogenPresetScale;
            chromogenPresetScale = findChromogenPresetScale(_this.props.catalog.presetScales, ((_a = newPlatform === null || newPlatform === void 0 ? void 0 : newPlatform.id) !== null && _a !== void 0 ? _a : (_b = _this.props.formState.platform) === null || _b === void 0 ? void 0 : _b.id), (_c = newChromogen !== null && newChromogen !== void 0 ? newChromogen : _this.props.formState.chromogenState.chromogen) !== null && _c !== void 0 ? _c : undefined, (_d = newScale !== null && newScale !== void 0 ? newScale : _this.props.formState.scale) !== null && _d !== void 0 ? _d : _this.props.catalog.defaultAutomatedProScale);
            return chromogenPresetScale;
        };
        _this.populateProbeStateWithPresetScale = function (probeState, probePresetScale) {
            return __assign(__assign({}, probeState), { probeScalePmol: probePresetScale.probeSetScalePmol, probeScaleUl: probePresetScale.probeSetScaleUl, probeHybridizationAScale: probePresetScale.probeHybridizationBufferUl, probeHybridizationBScale: probePresetScale.probeHybridizationBufferUl });
        };
        _this.findVariantForProbeSet = function (state) {
            var variant;
            _this.props.catalog.probeSet.catalog.organisms.forEach(function (o) {
                o.probeSetFamilies.forEach(function (psf) {
                    psf.variants.forEach(function (v) {
                        if (v.id === state.target.variantId) {
                            variant = v;
                        }
                    });
                });
            });
            return variant;
        };
        _this.customPriceFor = function (customPriceEnabled, priceCents) {
            return customPriceEnabled ? { effectivePriceCents: priceCents !== null && priceCents !== void 0 ? priceCents : 0, listPriceCents: 0 } : undefined;
        };
        return _this;
    }
    AdminEditKitForm.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var lockScalesAndToggles = this.props.formState.config !== ProKitConfig.Other;
        return React.createElement("div", { className: 'kit-form' },
            React.createElement(ErrorDisplay, { errors: this.props.formState.errors, errorPath: '/' }),
            React.createElement("div", null),
            React.createElement("div", { className: 'pro-kit-config-section' },
                React.createElement("div", { className: 'admin-kit-config-card' },
                    React.createElement("p", { className: 'kit-section-header' }, "Kit Configuration"),
                    React.createElement(Form, null,
                        React.createElement(Form.Group, { widths: 'equal', className: this.props.formState.config === ProKitConfig.Other ? 'config-group-with-other' : undefined },
                            React.createElement(Form.Field, null,
                                React.createElement("label", { className: 'field-label-uppercase' }, "Platform"),
                                React.createElement(Select, { fluid: true, options: this.props.catalog.proPlatforms.map(function (p) { return ({
                                        text: p.label,
                                        value: p.id,
                                        disabled: !p.plexity.includes(_this.props.formState.plexity)
                                    }); }), onChange: this.onProtocolChange, value: this.props.formState.platform.id })),
                            React.createElement(Form.Field, null,
                                React.createElement("label", { className: 'field-label-uppercase' }, "Configuration"),
                                React.createElement(Select, { fluid: true, options: this.props.kitConfigurations.map(function (bc) { return ({ text: bc, value: bc }); }), onChange: this.onConfigurationChange, value: this.props.formState.config })),
                            React.createElement(Form.Field, null,
                                React.createElement("label", { className: 'field-label-uppercase' }, "Scale"),
                                React.createElement(Select, { fluid: true, disabled: this.props.formState.config === ProKitConfig.StarterKitProbe, options: uniqueBy(this.effectiveScales(), function (s) { return s; }).map(function (s) { return ({ text: s, value: s }); }), onChange: this.onScaleChange, value: this.props.formState.scale, search: true })),
                            React.createElement(Form.Field, null,
                                React.createElement(FieldWithErrorDisplay, { errorPath: '/config', required: true, labelContent: React.createElement("label", { className: 'field-label-uppercase' }, "Plexity"), errors: this.props.formState.errors },
                                    React.createElement(Select, { fluid: true, options: [
                                            {
                                                text: "ONE PLEX",
                                                value: Plexity.OnePlex,
                                                disabled: !this.props.formState.platform.plexity.includes(Plexity.OnePlex)
                                            },
                                            {
                                                text: "TWO PLEX",
                                                value: Plexity.TwoPlex,
                                                disabled: !this.props.formState.platform.plexity.includes(Plexity.TwoPlex)
                                            }
                                        ], onChange: this.onPlexityChange, value: this.props.formState.plexity })))),
                        this.props.enableCustomPrice && (React.createElement(Form.Field, null,
                            React.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } },
                                React.createElement(Checkbox, { checked: this.props.formState.customPriceEnabled, label: React.createElement("label", null, "Enable Custom Pricing"), onChange: this.onCustomPriceEnabledChange })))),
                        this.props.formState.config === ProKitConfig.Other && (React.createElement("div", { className: 'other-config-box' },
                            React.createElement(Form.Group, null,
                                React.createElement(Form.Field, { width: 6 },
                                    React.createElement(FieldWithErrorDisplay, { errorPath: '/reasonForOther', required: true, labelContent: React.createElement("label", { className: 'field-label-uppercase' }, "Reason For Other"), errors: this.props.formState.errors },
                                        React.createElement(Select, { fluid: true, options: this.otherReasons(), onChange: this.onReasonForOtherChange, value: this.props.formState.reasonForOther }))),
                                React.createElement(Form.Field, { width: 8 },
                                    React.createElement(FieldWithErrorDisplay, { errors: this.props.formState.errors, errorPath: '/reasonForOtherExplanation', labelContent: React.createElement("label", { className: 'field-label-uppercase' }, "Additional Details") },
                                        React.createElement(Input, { fluid: true, onChange: this.onReasonForOtherExplanationChange, value: this.props.formState.reasonForOtherExplanation }))))))))),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.probeSetEnabled, otherComponentStates: [
                    this.props.formState.chromogenEnabled,
                    this.props.formState.miscComponentEnabled
                ], onChange: this.onProbeSetEnableChange, label: 'PROBE', cish: true }, this.props.formState.probeSetEnabled && this.props.formState.probeSetState
                .sort(function (s1, s2) { return s1.channel - s2.channel; })
                .map(function (pss, index) {
                var _a;
                var state = pss.state;
                return React.createElement(React.Fragment, { key: index },
                    index > 0 && React.createElement(Divider, { horizontal: true, className: 'probe-form-divider' },
                        "Channel ",
                        pss.channel),
                    React.createElement(ProbeSetForm, { protocolType: _this.props.formState.platform, channel: pss.channel, catalog: _this.props.catalog, errors: _this.props.formState.errors, enableCustomPrice: _this.props.enableCustomPrice, customPriceLocked: true, probePresetScale: pss.metadata, onProbeSetChange: _this.onProbeSetStateChange, onUserSelection: _this.onUserSelection, lockScales: lockScalesAndToggles, priceCents: _this.props.formState.price
                            ? (_a = _this.props.formState.price.effectivePrice.probeSetPriceCents
                                .find(function (price) { return price.channel === pss.channel; })) === null || _a === void 0 ? void 0 : _a.price : undefined, priceLoading: _this.props.formState.priceLoading, probeSetState: state }));
            })),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.detectEnabled, label: 'DETECT', otherComponentStates: [
                    this.props.formState.probeSetEnabled,
                    this.props.formState.chromogenEnabled,
                    this.props.formState.miscComponentEnabled
                ], onChange: this.onAmplifierEnableChange, cish: true }, this.props.formState.detectEnabled && React.createElement(AmplifierForm, { manualPro: false, plexity: this.props.formState.plexity, protocolType: this.props.formState.platform, lockScales: lockScalesAndToggles, detectState: this.props.formState.detectState, detectPresetScale: this.props.formState.detectPresetScale, catalog: this.props.catalog.proAmplifier, errors: this.props.formState.errors, hcrAmplifierDisabled: this.props.formState.probeSetEnabled, enableCustomPrice: this.props.enableCustomPrice, customPriceLocked: true, onDetectStateChange: this.onAmpStateChange, onChromogenStateChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, channel: Channel.Channel1, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.detectPriceCents : undefined, priceLoading: this.props.formState.priceLoading, detectComponent: (_b = (_a = this.props.formState.price) === null || _a === void 0 ? void 0 : _a.kit) === null || _b === void 0 ? void 0 : _b.detectComponent })),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.chromogenEnabled, label: 'CHROMOGEN', otherComponentStates: [
                    this.props.formState.probeSetEnabled,
                    this.props.formState.miscComponentEnabled
                ], onChange: this.onChromogenEnableChange, cish: true }, this.props.formState.chromogenEnabled && React.createElement(ChromogenForm, { protocolType: this.props.formState.platform, lockScales: lockScalesAndToggles, ampState: this.props.formState.detectState, chromogenState: this.props.formState.chromogenState, nonOtherKit: this.props.formState.config === ProKitConfig.ProbeDetect ||
                    this.props.formState.config === ProKitConfig.DetectOnly ||
                    this.props.formState.config === ProKitConfig.ExtrasOnly, detectEnabled: this.props.formState.detectEnabled, allScales: this.props.formState.scale, catalog: this.props.catalog.proChromogens, scaleOptions: this.props.catalog.automatedProScaleOptions, presetScales: this.props.formState.chromogenPresetScale, errors: this.props.formState.errors, enableCustomPrice: this.props.enableCustomPrice, customPriceLocked: true, onChromogenChange: this.onChromogenStateChange, onUserSelection: this.onUserSelection, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.chromogenPriceCents : undefined, priceLoading: this.props.formState.priceLoading, chromogenComponent: (_d = (_c = this.props.formState.price) === null || _c === void 0 ? void 0 : _c.kit) === null || _d === void 0 ? void 0 : _d.chromogenComponent })),
            React.createElement(ToggleableKitComponent, { disableToggle: lockScalesAndToggles, componentEnabled: this.props.formState.miscComponentEnabled, label: 'MISCELLANEOUS COMPONENT', otherComponentStates: [
                    this.props.formState.probeSetEnabled,
                    this.props.formState.detectEnabled,
                    this.props.formState.chromogenEnabled,
                ], onChange: this.onMiscComponentEnableChange, cish: true }, this.props.formState.miscComponentEnabled && React.createElement(MiscellaneousComponentForm, { miscComponentState: this.props.formState.miscComponentState, errors: this.props.formState.errors, onMiscComponentChange: this.onMiscComponentStateChange, priceLoading: this.props.formState.priceLoading, onUserSelection: this.onUserSelection, enableCustomPrice: this.props.enableCustomPrice, customPriceLocked: true, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.miscComponentPriceCents : undefined })),
            React.createElement(Grid, { columns: 4, stackable: true },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 12 },
                        React.createElement(Form.Field, null,
                            React.createElement("label", { htmlFor: 'comment' }, "Comment"),
                            React.createElement(Form.TextArea, { value: this.props.formState.comment, onChange: this.onCommentChange }))),
                    priceColumn(React.createElement("div", { className: 'price-column-padded' },
                        React.createElement(PriceDisplay, { loading: this.props.formState.priceLoading, priceCents: this.props.formState.price ? this.props.formState.price.effectivePrice.subtotalCents : undefined })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 16 }, this.props.formState.price && discountMessage(this.props.formState.price.discountCents, this.props.formState.price.listPrice.subtotalCents)))));
    };
    ;
    AdminEditKitForm.prototype.componentDidMount = function () {
        if (this.props.loadPriceOnMount) {
            this.loadPrice();
        }
    };
    AdminEditKitForm.serializeAutomatedProKit = function (formState) {
        var serializer = new RnaCishAdminKitSerializer(formState.platform, formState.config, formState.plexity, formState.scale, formState.detectPresetScale, formState.chromogenPresetScale);
        if (formState.probeSetEnabled) {
            serializer.setProbeSetState(formState.probeSetState);
        }
        if (formState.detectEnabled) {
            serializer.setDetect(formState.detectState);
        }
        if (formState.miscComponentEnabled) {
            serializer.setMiscComponent(formState.miscComponentState);
        }
        if (formState.chromogenEnabled) {
            serializer.setChromogenComponent(formState.chromogenState);
        }
        var reasonForOther;
        if (formState.reasonForOther !== "") {
            reasonForOther = formState.reasonForOther + " (" + formState.reasonForOtherExplanation + ")";
        }
        else {
            reasonForOther = "";
        }
        return serializer.serializeKit(formState.comment, reasonForOther);
    };
    return AdminEditKitForm;
}(React.PureComponent));
export default AdminEditKitForm;
export var defaultAutomatedProCatalogProbeSetState = function (catalog, hcrAmplifier, defaultProbePresetScale) {
    var _a, _b, _c, _d;
    return ({
        organism: RnaCishEditableOrganism.default(),
        target: RnaCishEditableTarget.default(20),
        hcrAmplifier: hcrAmplifier,
        targets: [],
        searchQuery: '',
        searchLoading: false,
        probeScalePmol: (_a = defaultProbePresetScale === null || defaultProbePresetScale === void 0 ? void 0 : defaultProbePresetScale.probeSetScalePmol) !== null && _a !== void 0 ? _a : 0,
        probeScaleUl: (_b = defaultProbePresetScale === null || defaultProbePresetScale === void 0 ? void 0 : defaultProbePresetScale.probeSetScaleUl) !== null && _b !== void 0 ? _b : 0,
        probeHybridizationAScale: (_c = defaultProbePresetScale === null || defaultProbePresetScale === void 0 ? void 0 : defaultProbePresetScale.probeHybridizationBufferUl) !== null && _c !== void 0 ? _c : 0,
        probeHybridizationBScale: (_d = defaultProbePresetScale === null || defaultProbePresetScale === void 0 ? void 0 : defaultProbePresetScale.probeHybridizationBufferUl) !== null && _d !== void 0 ? _d : 0
    });
};
export var defaultAutomatedProProbePresetScale = function (catalog, defaultPlatform, defaultPlexity) {
    return catalog.presetScales.presetProProbeScales.find(function (s) {
        return s.units === catalog.defaultAutomatedProScale
            && s.platform.id === defaultPlatform.id
            && s.designType === TargetDesignType.STANDARD
            && s.plexity === defaultPlexity;
    });
};
export var defaultAutomatedProDetectPresetScale = function (catalog, defaultPlexity, defaultPlatform) {
    return catalog.presetScales.presetProDetectScales.find(function (s) {
        return s.units === catalog.defaultAutomatedProScale
            && s.platform.id === defaultPlatform.id
            && s.plexity === defaultPlexity;
    });
};
export var defaultAutomatedProDetectState = function (catalog, platform, plexity, presetScale) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16;
    var ch1Channel;
    var ch2Channel;
    if (plexity === Plexity.OnePlex) {
        var config = catalog.userConfigs.oneTargetProAmps.proAmpConfigList.find(function (e) {
            return e.platformCompatibility.find(function (pc) { return pc.id === platform.id; }) &&
                e.isDefault;
        });
        ch1Channel = {
            config: config,
            hcrAmplifier: (_a = config === null || config === void 0 ? void 0 : config.amplifier) !== null && _a !== void 0 ? _a : catalog.defaultHcrAmplifier,
            hapten: (_b = config === null || config === void 0 ? void 0 : config.hapten) !== null && _b !== void 0 ? _b : catalog.defaultHapten,
            enzyme: (_c = config === null || config === void 0 ? void 0 : config.enzyme) !== null && _c !== void 0 ? _c : catalog.defaultEnzyme,
            editing: false,
            detectAntiHaptenUl: (_d = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAntiHaptenUl) !== null && _d !== void 0 ? _d : 0,
            detectTyramideUl: (_e = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectTyramideUl) !== null && _e !== void 0 ? _e : 0,
            detectEnzymeApUl: ((_f = config === null || config === void 0 ? void 0 : config.enzyme) === null || _f === void 0 ? void 0 : _f.id) !== EnzymeEnum.HRP ? ((_g = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeApUl) !== null && _g !== void 0 ? _g : 0) : 0,
            detectEnzymeHrpUl: ((_h = config === null || config === void 0 ? void 0 : config.enzyme) === null || _h === void 0 ? void 0 : _h.id) !== EnzymeEnum.AP ? ((_j = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeHrpUl) !== null && _j !== void 0 ? _j : 0) : 0,
            detectHrpQuencherUl: (_k = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectHrpQuencherUl) !== null && _k !== void 0 ? _k : 0
        };
    }
    else {
        var config = catalog.userConfigs.twoTargetProAmps.proAmpConfigList.find(function (e) {
            return e.platformCompatibility.find(function (pc) { return pc.id === platform.id; }) &&
                e.isDefault &&
                e.channelNum === Channel.Channel1;
        });
        var ch2Config = catalog.userConfigs.twoTargetProAmps.proAmpConfigList.find(function (e) {
            return e.platformCompatibility.find(function (pc) { return pc.id === platform.id; }) &&
                e.isDefault &&
                e.channelNum === Channel.Channel2;
        });
        ch1Channel = {
            config: config,
            hcrAmplifier: (_l = config === null || config === void 0 ? void 0 : config.amplifier) !== null && _l !== void 0 ? _l : catalog.defaultHcrAmplifier,
            hapten: (_m = config === null || config === void 0 ? void 0 : config.hapten) !== null && _m !== void 0 ? _m : catalog.defaultHapten,
            enzyme: (_o = config === null || config === void 0 ? void 0 : config.enzyme) !== null && _o !== void 0 ? _o : catalog.defaultEnzyme,
            editing: false,
            detectAntiHaptenUl: (_p = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAntiHaptenUl) !== null && _p !== void 0 ? _p : 0,
            detectTyramideUl: (_q = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectTyramideUl) !== null && _q !== void 0 ? _q : 0,
            detectEnzymeApUl: ((_r = config === null || config === void 0 ? void 0 : config.enzyme) === null || _r === void 0 ? void 0 : _r.id) !== EnzymeEnum.HRP ? ((_s = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeApUl) !== null && _s !== void 0 ? _s : 0) : 0,
            detectEnzymeHrpUl: ((_t = config === null || config === void 0 ? void 0 : config.enzyme) === null || _t === void 0 ? void 0 : _t.id) !== EnzymeEnum.AP ? ((_u = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeHrpUl) !== null && _u !== void 0 ? _u : 0) : 0,
            detectHrpQuencherUl: (_v = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectHrpQuencherUl) !== null && _v !== void 0 ? _v : 0
        };
        ch2Channel = {
            config: ch2Config,
            hcrAmplifier: (_w = ch2Config === null || ch2Config === void 0 ? void 0 : ch2Config.amplifier) !== null && _w !== void 0 ? _w : catalog.defaultHcrAmplifier,
            hapten: (_x = ch2Config === null || ch2Config === void 0 ? void 0 : ch2Config.hapten) !== null && _x !== void 0 ? _x : catalog.defaultHapten,
            enzyme: (_y = ch2Config === null || ch2Config === void 0 ? void 0 : ch2Config.enzyme) !== null && _y !== void 0 ? _y : catalog.defaultEnzyme,
            editing: false,
            detectAntiHaptenUl: (_z = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAntiHaptenUl) !== null && _z !== void 0 ? _z : 0,
            detectTyramideUl: (_0 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectTyramideUl) !== null && _0 !== void 0 ? _0 : 0,
            detectEnzymeApUl: ((_1 = ch2Config === null || ch2Config === void 0 ? void 0 : ch2Config.enzyme) === null || _1 === void 0 ? void 0 : _1.id) !== EnzymeEnum.HRP ? ((_2 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeApUl) !== null && _2 !== void 0 ? _2 : 0) : 0,
            detectEnzymeHrpUl: ((_3 = ch2Config === null || ch2Config === void 0 ? void 0 : ch2Config.enzyme) === null || _3 === void 0 ? void 0 : _3.id) !== EnzymeEnum.AP ? ((_4 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectEnzymeHrpUl) !== null && _4 !== void 0 ? _4 : 0) : 0,
            detectHrpQuencherUl: (_5 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectHrpQuencherUl) !== null && _5 !== void 0 ? _5 : 0
        };
    }
    return {
        channels: ch2Channel ? [ch1Channel, ch2Channel] : [ch1Channel],
        prefilled: false,
        pretreatADewaxUl: (_6 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatADewaxUl) !== null && _6 !== void 0 ? _6 : 0,
        pretreatBAntigenRetrievalUl: (_7 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatBAntigenRetrievalUl) !== null && _7 !== void 0 ? _7 : 0,
        pretreatBloxolUl: (_8 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.pretreatBloxolUl) !== null && _8 !== void 0 ? _8 : 0,
        detectAUl: (_9 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectAUl) !== null && _9 !== void 0 ? _9 : 0,
        detectBPmol: (_10 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBPmol) !== null && _10 !== void 0 ? _10 : 0,
        detectBConcentration: (_11 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBConcentration) !== null && _11 !== void 0 ? _11 : 0,
        detectBUl: (_12 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectBUl) !== null && _12 !== void 0 ? _12 : 0,
        detectCUl: (_13 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.detectCUl) !== null && _13 !== void 0 ? _13 : 0,
        postProcessAUl: (_14 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.postProcessAUl) !== null && _14 !== void 0 ? _14 : 0,
        postProcessBUl: (_15 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.postProcessBUl) !== null && _15 !== void 0 ? _15 : 0,
        preHybridizationUl: (_16 = presetScale === null || presetScale === void 0 ? void 0 : presetScale.preHybridizationUl) !== null && _16 !== void 0 ? _16 : 0,
        scalesExpanded: false,
    };
};
export var defaultChromogenState = function () {
    return {
        chromogen: { id: 'NONE', label: 'NONE', platformCompatibility: [], enzymeCompatibility: '', bufferCompatibility: { id: 'NONE', label: 'NONE' } },
        chromogenBuffer: { id: 'NONE', label: 'NONE' },
        chromogenScaleUl: 0,
        chromogenBufferScaleUl: 0,
        hematoxylinScaleUl: 0
    };
};
export var defaultAdminAutomatedProFormState = function (catalog) {
    var defaultPlexity = Plexity.OnePlex;
    var defaultPlatform = catalog.proPlatforms[0];
    var ampCatalog = catalog.proAmplifier;
    var defaultProbePresetScale = defaultAutomatedProProbePresetScale(catalog, defaultPlatform, defaultPlexity);
    var defaultProbeSetState = defaultAutomatedProCatalogProbeSetState(catalog, ampCatalog.defaultHcrAmplifier, defaultProbePresetScale);
    var defaultDetectPresetScale = defaultAutomatedProDetectPresetScale(catalog, defaultPlexity, defaultPlatform);
    var defaultDetectState = defaultAutomatedProDetectState(ampCatalog, defaultPlatform, Plexity.OnePlex, defaultDetectPresetScale);
    return {
        scale: catalog.defaultAutomatedProScale,
        plexity: defaultPlexity,
        platform: defaultPlatform,
        config: ProKitConfig.ProbeDetect,
        probeSetEnabled: true,
        probeSetState: [{ state: defaultProbeSetState, channel: 1, metadata: defaultProbePresetScale }],
        detectEnabled: true,
        detectState: defaultDetectState,
        detectPresetScale: defaultDetectPresetScale,
        chromogenEnabled: true,
        chromogenState: defaultChromogenState(),
        chromogenPresetScale: undefined,
        miscComponentEnabled: false,
        miscComponentState: defaultMiscComponentFormState(),
        customPriceEnabled: false,
        comment: '',
        reasonForOther: '',
        reasonForOtherExplanation: '',
        errors: [],
        price: undefined,
        priceLoading: false
    };
};
export var defaultMiscComponentFormState = function () {
    return {
        description: '',
        scaleInMl: 0,
        scaleInMlText: "0",
        scaleInSlides: 0,
        customPrice: {
            listPriceCents: 0,
            effectivePriceCents: 0
        }
    };
};
var MiscComponentStateWrangler = /** @class */ (function () {
    function MiscComponentStateWrangler() {
        this.buildHolderFromComponentState = function (componentFormState) { return ({ miscComponentState: componentFormState }); };
        this.extractComponentState = function (holder) { return holder.miscComponentState; };
    }
    return MiscComponentStateWrangler;
}());
var miscComponentStateWrangler = new MiscComponentStateWrangler();
export var populateDetectStateWithPresetScales = function (detectState, detectPresetScale) {
    return __assign(__assign({}, detectState), { pretreatADewaxUl: detectPresetScale.pretreatADewaxUl, pretreatBAntigenRetrievalUl: detectPresetScale.pretreatBAntigenRetrievalUl, pretreatBloxolUl: detectPresetScale.pretreatBloxolUl, detectAUl: detectPresetScale.detectAUl, detectBPmol: detectPresetScale.detectBPmol, detectBConcentration: detectPresetScale.detectBConcentration, detectBUl: detectPresetScale.detectBUl, detectCUl: detectPresetScale.detectCUl, postProcessAUl: detectPresetScale.postProcessAUl, postProcessBUl: detectPresetScale.postProcessBUl, preHybridizationUl: detectPresetScale.preHybridizationUl, channels: detectState.channels.map(function (ch) { return (__assign(__assign({}, ch), { detectAntiHaptenUl: detectPresetScale.detectAntiHaptenUl, detectTyramideUl: detectPresetScale.detectTyramideUl, detectEnzymeApUl: ch.enzyme.id !== EnzymeEnum.HRP ? detectPresetScale.detectEnzymeApUl : 0, detectEnzymeHrpUl: ch.enzyme.id !== EnzymeEnum.AP ? detectPresetScale.detectEnzymeHrpUl : 0, detectHrpQuencherUl: detectPresetScale.detectHrpQuencherUl })); }) });
};
export var populateChromogenStateWithPresetScales = function (chromogenState, chromogenPresetScale) {
    return __assign(__assign({}, chromogenState), { chromogenScaleUl: chromogenPresetScale.chromogenScaleUl, chromogenBufferScaleUl: chromogenPresetScale.chromogenBufferScaleUl, hematoxylinScaleUl: chromogenPresetScale.hemotoxylinScaleUl });
};
//# sourceMappingURL=AdminEditKitForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/AdminEditKitForm.js
// module id = 88
// module chunks = 0